<template>
  <div v-if="isToastOn" class="toast-wrapper">
    <div class="main-text">
      <p>
        <span class="font-weight-bold">2024년 1월 1일</span>부터 하이웍스 서비스는
        <span class="font-weight-bold">IE 브라우저 사용과 관련된 일체의 지원을 종료할 예정</span>입니다.
        <span class="responsive-block"></span>IE 브라우저 접속과 관련된 기능 개선 예정이 없으므로 원활한 하이웍스 이용을
        위해 <span class="font-weight-bold blue">Chrome 브라우저 등을 통해 접속</span>해주세요.
      </p>
    </div>
    <button class="cancel" @click="closeToast" />
  </div>
</template>

<script>
export default {
  name: 'IEServiceEndToast',
  data() {
    return {
      isToastOn: true,
    };
  },
  methods: {
    closeToast() {
      this.isToastOn = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.responsive-block {
  display: block;

  @media only screen and (max-width: 1280px) {
    display: inline-block;
  }

  @media only screen and (max-width: 900px) {
    display: block;
  }
}

.toast-wrapper {
  word-break: keep-all;
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 201;
  display: flex;
  align-items: center;
  gap: 14px;
  width: 1000px;
  padding: 0 10px;
  background: #eff9fd;
  font-size: 14px;
  border: 1px solid #22a3f4;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.08);
  letter-spacing: -0.2px;

  .main-text {
    flex: 1 1 auto;
  }

  .cancel {
    margin: 10px 0;
    flex: 0 0 16px;
    align-self: flex-start;
    content: '';
    height: 12px;
    background: url(./cancel.png) 50% 50% / contain no-repeat;
  }

  &:before {
    flex: 0 0 64px;
    content: '';
    height: 60px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAB4CAMAAAANIQqNAAABaFBMVEVHcEzw+f3w+vz0/v/v+v3v+v3v+v3w+v3v+v3w+v3v+fzv+f3v+v3w+fzr9vvv+f3v+fzw+f3u+fzv+f3u+f3v+v3v+fzv+vzv+fzv+fzv+f3w+fzv+fzv+fzv+f3v+vzv+fzu+fzw+f3v+fzl9/zv+v3v+f3v+v3w+v3v+fzw+v3v+f3v+v3v+fzv+v30///v+vzv+fzv+f3w+fzG7vrV8vshvvFEyfNq1fXJ7vq56vqt5vgTuvCg4/iH2/aa4fgyw/IPufAzw/IqwfKt5/lKyvMtwvJUzfR+2fd01vaV4Pey6vld0PWY4PjJ7/pWzvTK7/rF7vqf4vjL7/qZ4fjv+fwfvvDd9Pvg9fwgvvHk9vza8/vn9/yP3vcpwfEIt++V4PeD2/aK3Pcyw/J92fY8xvJr1PV21/am5fhcz/Rk0vVFyfOb4fhUzfSt5vlNy/Nx1fW+6/qg4/iy6PnO8PvG7fq46vkUu/BylrhaAAAAVXRSTlMA6fka8u/3/vX6/efsFxriwNzX0WhPszHMRay6N1hvxqVdQSz1fHYmPGIgSlSDnwOQipgRCv3MSyrz7eXtubHmaZqKsMXN4eiQ3aQ7eNKSs7jJdNxVtBOX0gAACgJJREFUaN7tmmlbGtkWhVtAHEBUBmeJaAGKCg4IOCO285wEFTXadq5RY4wxUfP375mHqjpKKZj+4ObxSb69rLPX2WuX5V9/vdVbvdVbvVUZKzGa+JP45KjHM/rnxCfrPHaPve4Pigd88JN8dXYmO5daLOwWdlPzuYz9tXuQnpv6/XuXVSGV9ryiDdPzJyeAXpA+c691BJm5qRMgvgB1Sz+pV3BcOpNOQfFcdyqXTafT2Xn4/1x5/TZ1ggt1voA6P5+1e9DHbs+kCse7yfKd+QmnU+2LuYzHTj+xWGz++DhbjlPPcjoSz3oOfI/uP9Afi0Wj0bXFz6V3QTInii/oPotZTIf4np7m9c+Lpb6JaensjQVOgdB7mpubO87OSjuPMymTzkufwvFxjuA7QC2dNZdFvtmd30V0UJ8X15oRvre3e+GqtYTDaE7Veayd4EGdfUT07tbWhZv+nhLzWecL4r8i/fPZ2dU6wvf3Ly0EAokS8h/pPKYDPqyrq2WIDwSuZzo7oyXj/zbruyge0wH+6urmfSAQGHh/vRwKBUrDp52fnzJqJ2fP6Vc3N9fvBwY6Vy/9fX19JbiJiSy95dmUeOn14q8QHtT19eVSXyi0stLn9/tbXzz86tJEbw4EjInrCf2M48EXuATwr6t+fzDof1EiJUbBbE+hfi+mIV++8wsLC4t68ZAO6uvq6pdIMBiMRDpesmDCZMvh7meYfuz6+fU1PHDeby0Z6KC+rGxAfDjsf754lG0Z1O85TyYlNj7H5l0vuPLLSzr8F1ibEB8OD8ae13ma7Eh31oP0s6Nfo9MWT5xA5xbFfyX4Hz/ONwE8PDg43Pk88STboQOnEJ/7bgvie/G4RRMH3Lllmf7j/Px8YxDUMKjkczpPP/OADzaNeeHKbyE6GbeQPtDZGQqtyvT/gdoE8KGhoZFWS+LriHb0Y88QvnDpFjoEOhQP8WDirOrwp6cbCD8yMmzlucouf3KAb4+ti/OulR49PntMBxMnuCLRT//99xOkj8Tj8Z5ixQvayc/iVDoWzfKkOztblsSHGD4Y3IR0jgdfYBvhu7oiljtPP+nCeiy6JibdEvedIB5NnMiGQP8E6p9JSO/qamurK6rzxPf831gst462W2HYb8ni/RgfQVd+GtEJ/h9Q3xC9ramp02LnyWYfjX4E+92WmHQwaM3Ew4EzOEiPHtO//fy5jfBNTV2JR8V7DL3Hmz3crZvX5WEvief0MLrys0z8N4j/ebED6e3t7Q29Sr6Jdr7Zg4HzUaTfXC/Jvosw8XDgDM2izkM6wl9cfED0hoZ36ptYZ9QubPYdHQtS0l0uzZCanpmm9ff036RmBfEXF9+/f5/AeFBKG46adJ5t9r29y7qc/XrJ590PdOdOme8gHHWe4n/9ekD4lpYWnzITEx4+92XxcN59vGF0Kel0E4e5XhD/C9TDA6K3+HzeBqUNR3nno6zzfLM3yVlMPxcGzifp6An+AdQtpoNqVAZC0uA7nrPLgnghZ/XiP5mKf7i9vb/1QXxjY2N9fZfahiZHj4d955KRLhz9qSn9O6UD/v29l+DrXS67sgc68TzpZsQNi4rndHz0et/ho0f0+/s7L6GDCittKDzPSjkburxWiRfnHe/8L0k8wN/dAbwL8StcXqUN7ZLveNLNcLwJXek7Rh+7GxvD4gEflPIhKYk73y1uWGDe+YU7z303S2pydhLVxOQEqfGJcVZj42OgtMM9pL0CV5PShj3yfkeG/Yzp0eMdZ4TmbBsd9mjewTvnw75Dra8n2mG53RXKB1WP2Hmy4/j9K+K8Y76T6G0yneOJ75h6N+C73YNKG3bTBUvYsFbNO9+FVhxK1+FlOhOP6KAaletxM18y+hAeBN2K2Hnuu524JL5doguXTjx7XJXuSuVeMmpcMjYV825Spus6/xgdVLvShq2GDWtaNe+aTHzn4/PO2HmIp6Vcj6MCHe84s5g+KyQdnncTat9p+pLwjkqHY0g5CkK6/W4TH/3GtnHivNP5rtFLjl47PBw7hLVHal8U74BVobRhN6WTDWubLPZxJp7PuxZz32kQLdD39zVRPK4+ZSTq9rsNdPSzI/FJY9KNtwi+q6ed14j2Q8bfE7WDqnZUV79T2jAkLLfgkW4WHf1OPN6mH/Zg1o97eeOp7zSuHdHhAUjiqyG/ulppw2ZMH0TPs0Nx/lwxKS4ZKOhA2LjItGWu1/b42RP+vkPCg3JWO51KGyaYeDjst5HvJtGVNywZ93cg6lzCpXNrBvX7+wcaPXwsHX4BUG6lDQeGydM8HPY7qPM76Mp/4Dl7S1Ie5OzYIbhlULtbY+qZdsg/cBjxNqfNplyPY4wOhv0k6jyZOBMm9EN65aDzmXb6BQ4YH+OdSDzE22wtShtGGL4LfAHQ+AkycVpM6Hq4pB3yj2jnndUCvcZWU6P8tV0vpYPGI999gHR4570KvEjf49rhVziQ8U6EB/Sa2tq4chqinMdRg3z3gc27eoo31c74B/sYDvTTznPxSH0tKIfyJUYfz1nkOx8f9mOGs9e7/kDkH/DGYzjUjui1tfl8UGlDnrPo0nmFpNMepYtsqN8pi6+xUXy+tiqf9yltOMxiHtneK+aspqbr+EdHTvnoBfG4upVbQVM78R2yPdsuXfVs1pt1/oDTjwD+iF15oh7Bqxg+n1c+pSXbaM6OQ9u7xGHvcrn3DOoP6IerP3IqOl/Fv0CN0oZBmrPj0PVj+v1OM847sfOoBLrNlA7KpRwFUWr7euR6/XJbabzzRrxNJz6vq9qm/kfepMWp7/Clk/a7SnAA+xqj6zuP8HrXV9XK2vOuQfujv7ELUN+5seU1tt1COkp4h2a0vayeNd6gvv3J14jJFuo7jdw5TasE2yXqvIZ3a0dl9YGkHVnP9mTn3cPFvLkIM9+hFY8nHaGzFc/pPDo6MviuRkXPN3QW9w41ynznIqaHcIFOdhww69me83TnK4eKf4Ha5mKuY481ejpNeSefOE6bYd6xehey8sokoH+qqqTqHeJ6R7JG3/kqA94xYvEFesJr8kwn4R26FecR3+V9z3htGebPdHrtNONJ1jxFr44/652lvcKgvVI6ezHmue8MnfcGn/vXE02C7xx69QL9EdfnbV29z39hO6B/otSJ18e8QXu+MfKiPx1JNJrTncX5ztbW/dIX9oNPiBfp+qoPl+APFuzixHHqxIudt5a0FqpNep7Vb7eKpHsyaS1Uv/Q8W8y8KyZpLU1DhzhxnE8lXZFJa2UaCr57yvXFJ60VGzqKnXeWktaKDYtyvdWktRLKZjvOi5PW0jR8svM+f1n/djuMtKuG/XOT1kLFnMqke0nSWrGhqvMvSlor09DU9S9NWitVbyL+5UlroSJlSVoLNVpTlqS1UF1lSVoL1V2WpLVsw5InrTUbliFprdiwPEn7Vv+d+j9kG1hhxZfJDQAAAABJRU5ErkJggg==)
      50% 50% / contain no-repeat;
  }

  @media only screen and (max-width: 1280px) {
    width: 680px;
    padding: 0 8px 0 10px;
    font-size: 13px;

    .main-text {
      padding: 5px 0 8px 0;
    }

    .cancel {
      margin: 5px 0;
    }
  }

  @media only screen and (max-width: 900px) {
    width: calc(100% - 40px);
    top: 63px;

    &:before {
      display: none;
    }
  }
}

.blue {
  color: #0982cc;
}

.font-weight-bold {
  font-weight: bold;
}
</style>
